import { buildIcs, type IcsSession } from '@gftg/shared';
import { sessionPath } from './paths';
import type { Session } from './queries';

export { icsFilename } from '@gftg/shared';

type ExportableSession = Session & { description?: string | null };

interface IcsEvent {
  name: string;
  venueName: string | null;
}

/**
 * SCH-03: a file the phone's own calendar can swallow, built here rather than fetched so that
 * starring a session and putting it in her calendar are one tap and no round trip. The feed of
 * SCH-04 is the same four days from the API, out of the same builder.
 */
export function sessionIcs(session: ExportableSession, event: IcsEvent): string {
  return buildIcs([toIcsSession(session)], icsOptions(event));
}

/** The whole personal schedule in one file (SCH-03), as a snapshot rather than a feed. */
export function scheduleIcs(sessions: ExportableSession[], event: IcsEvent): string {
  return buildIcs(sessions.map(toIcsSession), icsOptions(event));
}

export function downloadIcs(filename: string, contents: string): void {
  const url = URL.createObjectURL(new Blob([contents], { type: 'text/calendar;charset=utf-8' }));
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  link.click();
  URL.revokeObjectURL(url);
}

function icsOptions(event: IcsEvent) {
  // No calendar name and no refresh interval: this is a file, and both would describe a
  // subscription she did not make.
  return { eventName: event.name, venueName: event.venueName };
}

function toIcsSession(session: ExportableSession): IcsSession {
  return {
    id: session.id,
    title: session.title,
    startsAt: session.startsAt,
    endsAt: session.endsAt,
    roomName: session.roomName,
    roomLevel: session.roomLevel,
    description: session.description,
    isCancelled: session.isCancelled,
    trackName: session.track?.name ?? null,
    url: `${window.location.origin}${sessionPath(session)}`,
  };
}
